Namespace 'Monitoring.Reports.FacebookActivity'

class Monitoring.Reports.FacebookActivity.HeaderView extends Backbone.View
  className: 'header'
  template: JST['backbone/templates/monitoring/reports/facebook_activity/header']

  events:
    'click #share': 'share'
    'click #build': 'build'
    'click #pdf': 'exportPDF'
    'change #month_to': 'validateDateCombos'

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    @$el.html(@template(@options))
    threeYearsAgo = new Date()
    threeYearsAgo.setFullYear(threeYearsAgo.getFullYear() - 3)
    @$('.date').datepicker(
      autoclose: true
      startDate: threeYearsAgo
      # endDate: new Date()
      format: 'yyyy-mm-dd'
      todayBtn: 'linked'
      todayHighlight: true
    )
    @$el.find('#to, #from').datepicker('setEndDate', new Date())
    @$el.find('#from').prop('disabled', true)
    @$el.find('#offsetted_date').prop('disabled', true) unless @thereIsOffset()
    @$el.find('#to').datepicker().on 'changeDate', @updateDates
    @updateDates()
    @$el.find('#select-fb-id').chosen(width: '100%', inherit_select_classes: true)
    @$el.find('#month_from').chosen(width: '85px', inherit_select_classes: true)
    @$el.find('#month_to').chosen(width: '85px', inherit_select_classes: true)
    @$el.find('#month_from').prop('disabled', true).trigger("chosen:updated")
    if @dailyFilters()
      @$el.find('.date-selector .chosen-container').hide()
    else
      @$el.find('#from, #to').hide()
      @updateMonth()

  updateDates: =>
    date_until = @$('#to').datepicker('getDate')
    @$('#offsetted_date').datepicker('setStartDate', date_until)
    date_since = new Date(date_until)
    date_since.setDate(date_since.getDate() - 6) # the 'from' date is just symbolic
    @$('#from').datepicker('update', date_since)
    offsetted_date = new Date(date_until)
    @$('#offsetted_date').datepicker('update', offsetted_date)
    @$('#offsetted_date').datepicker('setEndDate', new Date())

  updateMonth: =>
    date = @$el.find('#month_to').val()
    @$el.find('#to').val(date)
    @$el.find('#to').datepicker('update')
    @updateDates()
    val = @$el.find('#month_to').val()
    @$el.find('#month_from').val("#{val[0..6]}-01").trigger('chosen:updated')

  reportParams: =>
    params =
      from: @_isoDate('#from')
      to: @_isoDate('#to')
      offsetted_date: @_isoDate('#offsetted_date')
      id: @$('#select-fb-id').val()
      mode: @options.mode # one of: weekly, old_weekly

  build: =>
    @setEnable(false)
    params = @reportParams()
    url = "facebook_activity/#{params.mode}?from=#{params.from}&to=#{params.to}&offsetted_date=#{params.offsetted_date}&id=#{params.id}"
    window.open(url, '_blank')
    setTimeout(@setEnable, 3000)

  share: =>
    @setEnable(false)
    params = @reportParams()
    $.ajax
      method: 'post'
      url: '/monitoring/reports/facebook_activity/share'
      data: params
      success: @showSharedAlert

  showSharedAlert: (shared) =>
    @setEnable(true)
    textarea = $('<textarea/>').attr('rows', 3).attr('onclick', 'this.select()').css('width', '400px').html(shared.url)
    swal
      title: I18n.t('monitoring.reports.facebook_activity.shared'),
      type: 'success'
      text: $('<div/>').append(textarea).html()
      html: true

  exportPDF: =>
    @$('#pdf').attr('disabled', true)
    params = @reportParams()
    swal
      title: "Export started!",
      type: 'success'
      text: "We will send you an email once it's completed"
      html: true
    $.ajax
      method: 'post'
      url: '/monitoring/reports/facebook_activity/share'
      data: params
      success: @createPDF

  createPDF: (token_url) =>
    params = {
      token_url: token_url.url,
      format : 'pdf',
      type: @options.mode
    }
    $.ajax
      method: 'post'
      url: '/monitoring/reports/exporter/export'
      data: params
      success: @waitForDownload

  waitForDownload: (response) =>
    @jobId = response.job_id
    @_askIfCompleted()

  _askIfCompleted : =>
    $.get('/monitoring/reports/exporter/export_finish', {job_id: @jobId}, (response) =>
      if response.status == 'completed'
        @$('#pdf').attr('disabled', false)
      else if response.status != 'not_found' && response.status != 'failed' 
        setTimeout(@_askIfCompleted, 2000)
      else 
        showError(I18n.t('monitoring.reports.export_fail'))
        @$('#pdf').attr('disabled', false)
    )
    
  _isoDate: (selector) =>
    # returns a yyyy-mm-dd string from a datepicker
    @$(selector).datepicker('getDate').toISOString().substring(0, 10)

  reableOptions: =>
    @change_enable(true)

  setEnable: (value) =>
    value = true unless value?
    value = !value
    @$('#to').attr('disabled', value)
    @$('#offsetted_date').attr('disabled', value) if @thereIsOffset()
    @$('#select-fb-id').attr('disabled', value).trigger("chosen:updated")
    @$('#share').attr('disabled', value)
    @$('#build').attr('disabled', value)
    @$('#pdf').attr('disabled', value)

  thereIsOffset: =>
    @options.mode != 'old_weekly'

  dailyFilters: =>
    @options.mode != 'monthly'

  validateDateCombo: (combo, comparison, other_combo) ->
    $combo = $ combo
    $other_combo = $ other_combo
    date = @utcDate $combo.val()
    other_date = @utcDate $other_combo.val()
    if eval('date ' + comparison + ' other_date')
      @$el.removeClass 'erroneous'
      @$el.find('button').attr('disabled', false)
    else
      @$el.addClass 'erroneous'
      @$el.find('button').attr('disabled', true)

  validateDateCombos: (e, a) ->
    @updateMonth() # this goes first
    combo_from = $ '#month_from'
    combo_to = $ '#month_to'
    @validateDateCombo combo_from, '<=', combo_to
    @validateDateCombo combo_to, '>=', combo_from

  utcDate: (date_str) ->
    now = new Date date_str
    new Date(now.getTime() + now.getTimezoneOffset() * 60000)
